var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.14,20.27H4.75c-1,0-1.89-0.52-2.39-1.39s-0.49-1.9,0.02-2.76L9.62,3.85C10.12,3.01,11,2.5,11.99,2.5c0,0,0.01,0,0.01,0 c0.99,0,1.87,0.51,2.37,1.37l7.11,12.22c0.53,0.84,0.55,1.88,0.06,2.77S20.15,20.27,19.14,20.27z M11.99,4 c-0.45,0-0.85,0.23-1.08,0.62L3.68,16.88c-0.23,0.39-0.23,0.86-0.01,1.26c0.23,0.39,0.63,0.63,1.09,0.63h14.38 c0.46,0,0.87-0.24,1.09-0.64s0.21-0.88-0.04-1.27L13.07,4.62l0,0C12.84,4.23,12.44,4,11.99,4C11.99,4,11.99,4,11.99,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,13.66C12,13.66,12,13.66,12,13.66c-0.42,0-0.75-0.34-0.75-0.76l0.04-5.16C11.3,7.33,11.63,7,12.04,7c0,0,0,0,0.01,0 c0.41,0,0.75,0.34,0.74,0.76l-0.04,5.16C12.75,13.33,12.41,13.66,12,13.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15.25c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S12.55,15.25,12,15.25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert_triangle.27c22f2b654168c359a1c87520f64c0c.svg";
export { ForwardRef as ReactComponent };